"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionsUtils = function () {
    function ConditionsUtils() {
        (0, _classCallCheck3.default)(this, ConditionsUtils);
    }

    (0, _createClass3.default)(ConditionsUtils, null, [{
        key: "toOrQueryFragment",
        value: function toOrQueryFragment(children) {
            var aggregate = children.reduce(function (conditions, child) {
                var qf = child.toQueryFragment();
                if (qf) {
                    conditions.push(qf);
                }
                return conditions;
            }, []);
            if (aggregate.length === 0) {
                // $and/$or/$nor must be a nonempty array
                return null;
            }
            if (aggregate.length === 1) {
                // unwrap OR condition with one child
                return aggregate[0];
            }
            return { $or: aggregate };
        }
    }, {
        key: "toAndQueryFragment",
        value: function toAndQueryFragment(children) {
            if (children.some(function (child) {
                return !child.toQueryFragment();
            })) {
                // if any of the children is falsy, the AND will be resolved to false
                return null;
            }

            var aggregate = children.reduce(function (conditions, child) {
                var qf = child.toQueryFragment();
                if (qf) {
                    conditions.push(qf);
                }
                return conditions;
            }, []);

            if (aggregate.length === 0) {
                // $and/$or/$nor must be a nonempty array
                return null;
            }
            if (aggregate.length === 1) {
                // unwrap AND condition with one child
                return aggregate[0];
            }

            return { $and: aggregate };
        }
    }]);
    return ConditionsUtils;
}();

exports.default = ConditionsUtils;